import _ from 'lodash';

export default function DatapointdisplayService(ConfigService, DatapointdisplayObjects, $rootScope) {
	'ngInject';

	var service = {
		getAllDatapointDisplayList: getAllDatapointDisplayList,
		getDatapointDisplayForPackageAndModules: getDatapointDisplayForPackageAndModules,
		createPackagesLookupTable: createPackagesLookupTable,
		createModulesLookupTable: createModulesLookupTable,
		getDatapointListForPackageAndModules: getDatapointListForPackageAndModules,
		formatCurrentDatapointDisplay: formatCurrentDatapointDisplay,
		getModulesForPackage: getModulesForPackage,
		saveDatapointdisplay: saveDatapointdisplay,
		updateCashedDatapointdisplayData: updateCashedDatapointdisplayData,
		toggleAggregate: toggleAggregate,
		CreateDatapointMapObject: CreateDatapointMapObject,
		getDatapointListStatus: getDatapointListStatus
	};

	///===================
	function getAllDatapointDisplayList() {
		return ConfigService.getDatapointDisplayList();
	}

	function createPackagesLookupTable(packageListData) {
		var packages = _.filter(packageListData, function(e) {
			return e.type === 'package';
		});
		return _.KeyBy(_.sortBy(packages, 'attributes.name'), 'id');
	}

	function createModulesLookupTable(packageListData) {
		return _.KeyBy(
			_.filter(packageListData, function(e) {
				return e.type === 'module';
			}),
			'id'
		);
	}

	// return data point display for the combination of package and modules if exist
	function getDatapointDisplayForPackageAndModules(packageId, moduleIds, datapointDisplayListData) {
		if (!packageId) {
			return null;
		}

		if (!_.isArray(moduleIds)) moduleIds = [];

		if (!datapointDisplayListData) {
			return null;
		}

		var datapointDisplayByPackageTable = _.groupBy(datapointDisplayListData, function(item) {
			return item.relationships.package.data.id;
		});

		var dpd = _.find(datapointDisplayByPackageTable[packageId], function(entry) {
			return (
				_.xor(
					_.map(entry.relationships.modules.data, function(module) {
						return module.id;
					}),
					moduleIds
				).length === 0
			);
		});

		return dpd;
	}

	//return a list of conmbined  datapoints in the package and modules configured by datapointdisplay object if exist
	function getDatapointListForPackageAndModules(
		selectedPackageId,
		selectedModuleIds,
		datapointDisplayListData,
		packagesTable,
		modulesTable
	) {
		if (!selectedPackageId) {
			return [];
		}

		if (!_.isArray(selectedModuleIds)) selectedModuleIds = [];

		var datapointDisplayConfig = getDatapointDisplayForPackageAndModules(
			selectedPackageId,
			selectedModuleIds,
			datapointDisplayListData
		);

		var datapointDict = {};

		var selectedEntities = [];

		var datapointList = [];

		if (selectedModuleIds.length > 0) {
			for (var i = 0; i < selectedModuleIds.length; i++) {
				selectedEntities.push(modulesTable[selectedModuleIds[i]]);
			}
		}

		if (selectedPackageId) {
			selectedEntities.push(packagesTable[selectedPackageId]);
		}

		for (let i = 0; i < selectedEntities.length; i++) {
			const entity = selectedEntities[i];

			if (entity) {
				if (entity.relationships) {
					if (entity.relationships.datapoints) {
						for (var j = 0; j < entity.relationships.datapoints.data.length; j++) {
							datapointDict[entity.relationships.datapoints.data[j].id] = true;
						}
					}
				}
			}
		}

		var keys = Object.keys(datapointDict);

		//Manually add speed and gps

		keys.push('gps');
		keys.push('speed');

		var unconfiguredItems = [];

		if (datapointDisplayConfig) {
			//Iterate through the datapoints that have been configured on this current configuration
			//Sort by the display items
			const sortedDisplayItems = _.sortBy(datapointDisplayConfig.attributes.displayItems, 'ordinal');

			const items = sortedDisplayItems
				.map(item => ({
					id: item.dataId,
					displayItem: item
				}))
				.filter(item => item.displayItem.dataId != null && item.displayItem.dataId.length > 0);

			for (let i = 0; i < items.length; i++) {
				datapointList.push(items[i]);
			}

			//Add all of the datapoints in the keys that aren't in the display items data id field
			unconfiguredItems = keys.filter(
				key => !datapointDisplayConfig.attributes.displayItems.find(f => f.dataId === key)
			);
		} else {
			unconfiguredItems = keys;
		}

		for (let i = 0; i < unconfiguredItems.length; i++) {
			var aggregateFunctions = DatapointdisplayObjects.getAggregateFunctions();
			datapointList.push({
				id: unconfiguredItems[i],
				unconfigured: true,
				displayItem: {
					visible: true,
					dataId: unconfiguredItems[i],
					aggregates: aggregateFunctions.map(func => func.value)
				} //Empty object with defaults
			});
		}

		return datapointList;
	}

	// //Format the current view variables to a datapoint display model for the api
	function formatCurrentDatapointDisplay(datapointList) {
		if (!_.isArray(datapointList)) {
			datapointList = [];
		}
		var datapointDisplay = {};

		datapointDisplay.displayItems = [];
		//Push all of the items onto the datapoint display
		for (var i = 0; i < datapointList.length; i++) {
			var item = datapointList[i];
			item.displayItem.ordinal = i;

			item.displayItem.valueColorMap = {
				'0': '#ffffff',
				'1': '#000000'
			};

			datapointDisplay.displayItems.push(item.displayItem);
		}
		return datapointDisplay;
	}

	//return modules list that can be apply to the package
	function getModulesForPackage(packageId, packagesTable, modulesTable) {
		if (!packageId) {
			return [];
		}

		if (!packagesTable[packageId]) return [];

		var modules = packagesTable[packageId].relationships.modules.data;
		var mapped = _.map(modules, function(e) {
			return modulesTable[e.id];
		});

		var sorted = _.sortBy(mapped, function(e) {
			//null check
			if (angular.isDefined(e)) {
				if (e.attributes) {
					return e.attributes.name.toLowerCase();
				}
			}

			return '';
		});

		return sorted;
	}

	function saveDatapointdisplay(selectedPackageIds, selectedModuleIds, datapointList) {
		var newDatapointDisplay = this.formatCurrentDatapointDisplay(datapointList);
		return ConfigService.createDatapointDisplayForPackageAndModules(
			selectedPackageIds,
			selectedModuleIds,
			newDatapointDisplay
		);
	}

	function updateCashedDatapointdisplayData(datapointDisplayListData, savedConfigData) {
		var index = _.findIndex(datapointDisplayListData, function(config) {
			return config.id == savedConfigData.id;
		});

		if (index >= 0) {
			datapointDisplayListData[index] = savedConfigData;
		} else {
			datapointDisplayListData.push(savedConfigData);
		}

		return datapointDisplayListData;
	}

	function toggleAggregate(currentAggregateList, aggregatevalue) {
		currentAggregateList = !_.isArray(currentAggregateList) ? ['mean'] : currentAggregateList;

		if (currentAggregateList.indexOf(aggregatevalue) < 0) {
			currentAggregateList.push(aggregatevalue);
		} else {
			if (currentAggregateList.length > 1) {
				_.pull(currentAggregateList, aggregatevalue);
			}
		}

		return currentAggregateList;
	}

	function CreateDatapointMapObject() {
		var datapointList = $rootScope.currentUser.visibleDatapoints;
		var keyValueMap = {};
		_.each(datapointList, function(e) {
			keyValueMap[e.id] = e.description;
		});
		return keyValueMap;
	}

	function getDatapointListStatus(datapointList) {
		if (!_.isArray(datapointList)) {
			return null;
		}
		var unConfiguredItems = _.filter(datapointList, function(item) {
			return item.unconfigured;
		});

		if (unConfiguredItems.length === datapointList.length) {
			return null;
		} else if (unConfiguredItems.length == 0) {
			return 'all-configured';
		} else {
			return 'part-configured';
		}
	}

	return service;
}
